import { type SituationWithDetails } from '../../Situation/Situation.types';
import { TrafikenConfig } from '../TrafikenConfig';
import { AjaxSource } from './AjaxSource';

import type { Feature } from 'geojson';
import type { AjaxSourceOptions } from './Sources.types';

const defaultOptions = (region: string, trafficType?: string, geoPageId?: number) => ({
    id: 'situation-source',
    url:
        `${TrafikenConfig.infoLayerServiceBaseUrl}/api/trafficmessages?region=${region}` +
        (trafficType ? '&trafficType=' + trafficType : '') +
        (geoPageId ? '&geoareaid=' + geoPageId : ''),
    displayName: trafficType == 'Vägtrafik' ? 'Störningar och vägarbeten' : 'Störningar',
});

export class SituationSource extends AjaxSource<AjaxSourceOptions> {
    constructor(region: string, trafficType?: string, geoPageId?: number, options?: Partial<AjaxSourceOptions>) {
        super({ ...defaultOptions(region, trafficType, geoPageId), ...options });
    }

    parseData(situations: SituationWithDetails | SituationWithDetails[]): Feature[] {
        if (!Array.isArray(situations)) {
            situations = [situations];
        }
        return situations.map((i) => ({
            id: i.id,
            type: 'Feature',
            geometry: i.wgs84Position,
            properties: i,
        }));
    }
}
